<template>
  <div id="container">
    <div id="wrapper">
      <el-form ref="loginForm" :model="form" :rules="rules" class="login-box" label-width="80px">
        <h3 class="login-title">欢迎登录</h3>
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username"
                    placeholder="请输入账号"
                    type="text"/>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password"
                    placeholder="请输入密码"
                    type="password"
                    @keyup.enter.native="onSubmit('loginForm')"/>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-login"
                     type="primary"
                     @click="onSubmit('loginForm')">
            登录
          </el-button>
        </el-form-item>
        <span class="register">还没有账号？请 <router-link :to="{name:'register'}"
                                                          style="color: #409EFF">注册</router-link></span>
        <router-link :to="{name:'getBackPassword'}" class="right" style="color: #409EFF">忘记密码？</router-link>
      </el-form>

      <el-dialog
          :before-close="handleClose"
          :show-close="false"
          :visible.sync="dialogVisible"
          title="温馨提示"
          width="30%"
      >
        <span>账号或密码错误！</span>
        <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogVisible=false">确 定</el-button>
                 </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import utils from '@/utils/utils'

export default {
  name: "login",
  data() {
    return {
      form: {
        username: '',
        password: ''
      },

      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        username: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.utils.testPhoneNumber(value)) {
                callback();
              } else {
                callback(new Error('请输入正确的手机号码'));
              }
            },
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true, message: '密码不可为空', trigger: 'blur'
          }
        ]
      },

      // 对话框显示和隐藏
      dialogVisible: false
    }
  },
  mounted() {
    // console.log(this.$route.query)
  },
  methods: {
    onSubmit(formName) {
      // 为表单绑定验证功能
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading({
            lock: true,
            text: '请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
          });
          this.$request.login({
            username: this.form.username,
            password: this.form.password
          }).then((res) => {
            loading.close();
            if (res.status == 200) {
              Cookies.set(utils.getTokenKey(), JSON.stringify({yzb: {yzbToken: res.data}}), {
                domain: "localhost"
              })
              Cookies.set(utils.getTokenKey(), JSON.stringify({yzb: {yzbToken: res.data}}), {
                domain: ".caigou2003.com"
              })
              // 使用 vue-router 路由到指定页面，编程式导航
              if (this.$route.query.routerName) {
                this.$router.push({
                  name: this.$route.query.routerName,
                  query: this.$route.query.query
                });
              } else {
                this.$router.push({
                  name: 'backHome'
                });
              }

            } else {
              this.requestError(res.status, res.message)
            }
          }, (err) => {
            console.log(err)
            loading.close();
            this.requestFail(err);
          })
        } else {
          this.dialogVisible = true;
          return false;
        }
      });
    },
    handleClose() {

    }
  }
}
</script>

<style lang="less" scoped>
#container {
  overflow: hidden;

  #wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    .login-box {
      border: 1px solid #DCDFE6;
      width: 350px;
      /*margin: 250px auto;*/
      padding: 35px 35px 15px 35px;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      box-shadow: 0 0 25px #909399;
    }

    .login-title {
      text-align: center;
      margin: 0 auto 40px auto;
      color: #303133;
    }

    .btn-login {
      width: 80px;
      height: 35px;
      float: right;
      text-align: center;
    }
  }
}
</style>